<script>
import DatePicker from "vue2-datepicker"; // add DatePicker
import Multiselect from "vue-multiselect"; // add Multiselect
import {
  required,
  minLength,
  maxLength,
  requiredIf,
  minValue,
  maxValue,
} from "vuelidate/lib/validators";
import { fileSize, fileType } from "../../../helpers/validators_files";

import gender from "../../../helpers/list/gender";
import marital_status from "../../../helpers/list/marital_status";
import certificate from "../../../helpers/list/certificate";
import city from "../../../helpers/list/city";

import own_property from "../../../helpers/list/own_property";
import house_type from "../../../helpers/list/house_type";
import construction_type from "../../../helpers/list/construction_type";
import housing_privacy from "../../../helpers/list/housing_privacy";
import construction_condition from "../../../helpers/list/construction_condition";
import health_status from "../../../helpers/list/health_status_injured";
import families_martyrs from "../../../helpers/list/families_martyrs";
import continuing_serve from "../../../helpers/list/continuing_serve";
import martyr_class from "../../../helpers/list/martyr_class";
import government_grants from "../../../helpers/list/government_grants";

export default {
  components: { DatePicker, Multiselect },
  props: {},
  data() {
    return {
      name1: "",
      name2: "",
      name3: "",
      name4: "",
      family_name: "",
      mother_name: "",
      birth_date: "",
      gender_id: "",

      phone1: "",
      marital_status_id: "",
      certificate_id: "",
      academic_specialization: "",
      dept: "",
      disability_ratio: "",
      injury_date: "",
      scene_accident: "",
      employment_date: "",
      id_type: "1",
      national_id_number: "",
      nationality_number: "",
      national_id_number_record: "",
      national_id_number_paper: "",

      city_id: "",
      district: "",
      region: "",
      mahla: "",
      zqaq: "",
      dar: "",

      own_property_id: "",
      house_type_id: "",
      construction_type_id: "",
      housing_privacy_id: "",
      construction_condition_id: "",
      housing_area: "",
      number_floors: "",

      health_status_id: [],
      families_martyrs_id: "",
      martyr_class_id: "",
      continuing_serve_id: "",
      retirement_number: "",
      government_grants_id: [],

      attachment_basic: "",
      attachment_health: "",
      attachment_families_martyrs: "",
      attachment_disability_ratio: "",

      //lists
      list_gender: gender,
      list_marital_status: marital_status,
      list_certificate: certificate,
      list_city: city,
      list_own_property: own_property,
      list_house_type: house_type,
      list_construction_type: construction_type,
      list_housing_privacy: housing_privacy,
      list_construction_condition: construction_condition,
      list_families_martyrs: families_martyrs,
      list_martyr_class: martyr_class,
      list_continuing_serve: continuing_serve,
      list_health_status: health_status.map((x) => {
        return {
          id: x.id,
          name: x.name,
          $isDisabled: false,
        };
      }),
      list_government_grants: government_grants.map((x) => {
        return {
          id: x.id,
          name: x.name,
          $isDisabled: false,
        };
      }),
    };
  },
  validations: {
    name1: { required, minLength: minLength(2), maxLength: maxLength(15) },
    name2: { required, minLength: minLength(2), maxLength: maxLength(15) },
    name3: { required, minLength: minLength(2), maxLength: maxLength(15) },
    name4: { required, minLength: minLength(2), maxLength: maxLength(15) },
    family_name: { required, minLength: minLength(2), maxLength: maxLength(15) },
    mother_name: { required, minLength: minLength(2), maxLength: maxLength(50) },
    birth_date: {
      required,
      maxValue(val) {
        if (val != null) {
          val = val.split("-");
          const d = new Date();
          return (
            new Date(val[2], val[1], val[0]) <=
            new Date(d.getFullYear() - 18, d.getMonth() + 1, d.getDate())
          );
        }
        return true;
      },
      minValue(val) {
        if (val != null) {
          val = val.split("-");
          const d = new Date();
          return (
            new Date(val[2], val[1], val[0]) >=
            new Date(d.getFullYear() - 62, d.getMonth() + 1, d.getDate())
          );
        }
        return true;
      },
    },
    gender_id: { required },

    phone1: { required, minLength: minLength(11), maxLength: maxLength(11) },
    marital_status_id: { required },
    certificate_id: { required },
    academic_specialization: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(50),
    },
    dept: { required, minLength: minLength(2), maxLength: maxLength(50) },
    disability_ratio: { required, minValue: minValue(1), maxValue: maxValue(100) },
    injury_date: {
      required,
      maxValue(val) {
        if (val != null) {
          val = val.split("-");
          let date = val[2] + "-" + val[1] + "-" + val[0];
          return date <= new Date().toISOString().substring(0, 10);
        }
        return true;
      },
    },
    scene_accident: { required, minLength: minLength(2), maxLength: maxLength(50) },
    employment_date: {
      required,
      maxValue(val) {
        if (val != null) {
          val = val.split("-");
          let date = val[2] + "-" + val[1] + "-" + val[0];
          return date <= new Date().toISOString().substring(0, 10);
        }
        return true;
      },
    },
    id_type: { required },
    nationality_number: {
      required: requiredIf(function () {
        return this.getNationalityNumber();
      }),
      minLength: minLength(12),
      maxLength: maxLength(12),
    },
    national_id_number: {
      required: requiredIf(function () {
        return this.getNationalIdNumber();
      }),
      minLength: minLength(8),
      maxLength: maxLength(8),
    },
    national_id_number_record: {
      required: requiredIf(function () {
        return this.getNationalIdNumber();
      }),
      minLength: minLength(1),
      maxLength: maxLength(5),
    },
    national_id_number_paper: {
      required: requiredIf(function () {
        return this.getNationalIdNumber();
      }),
      minLength: minLength(1),
      maxLength: maxLength(5),
    },

    city_id: { required },
    district: { required, minLength: minLength(2), maxLength: maxLength(50) },
    region: { required, minLength: minLength(2), maxLength: maxLength(50) },
    mahla: {},
    zqaq: {},
    dar: {},

    own_property_id: { required },
    house_type_id: { required },
    construction_type_id: { required },
    housing_privacy_id: { required },
    construction_condition_id: { required },
    housing_area: { required, minValue: minValue(50), maxValue: maxValue(1200) },
    number_floors: { required, minValue: minValue(1), maxValue: maxValue(4) },

    health_status_id: { required },
    families_martyrs_id: { required },
    martyr_class_id: {
      required: requiredIf(function () {
        return this.getFamiliesMartyrs();
      }),
    },
    continuing_serve_id: { required },
    government_grants_id: { required },
    retirement_number: {
      required: requiredIf(function () {
        return this.getContinuingServe();
      }),
      minLength: minLength(6),
      maxLength: maxLength(10),
    },
    attachment_basic: {
      required,
      fileType: fileType(["application/pdf", "image/jpg", "image/jpeg", "image/png"]),
      fileSize: fileSize(1024 * 1024 * 5),
    },
    attachment_disability_ratio: {
      required,
      fileType: fileType(["application/pdf", "image/jpg", "image/jpeg", "image/png"]),
      fileSize: fileSize(1024 * 1024 * 5),
    },
    attachment_health: {
      required: requiredIf(function () {
        return this.getHealthStatus();
      }),
      fileType: fileType(["application/pdf", "image/jpg", "image/jpeg", "image/png"]),
      fileSize: fileSize(1024 * 1024 * 5),
    },
    attachment_families_martyrs: {
      required: requiredIf(function () {
        return this.getFamiliesMartyrs();
      }),
      fileType: fileType(["application/pdf", "image/jpg", "image/jpeg", "image/png"]),
      fileSize: fileSize(1024 * 1024 * 5),
    },
    form: [
      "name1",
      "name2",
      "name3",
      "name4",
      "family_name",
      "mother_name",
      "birth_date",
      "gender_id",
      "phone1",
      "marital_status_id",
      "certificate_id",
      "academic_specialization",
      "dept",
      "disability_ratio",
      "injury_date",
      "scene_accident",
      "employment_date",
      "id_type",
      "national_id_number",
      "nationality_number",
      "national_id_number_record",
      "national_id_number_paper",
      "city_id",
      "district",
      "region",
      "mahla",
      "zqaq",
      "dar",
      "own_property_id",
      "house_type_id",
      "construction_type_id",
      "housing_privacy_id",
      "construction_condition_id",
      "housing_area",
      "number_floors",
      "health_status_id",
      "families_martyrs_id",
      "martyr_class_id",
      "continuing_serve_id",
      "retirement_number",
      "government_grants_id",
      "attachment_basic",
      "attachment_health",
      "attachment_families_martyrs",
      "attachment_disability_ratio",
    ],
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },

    // getContinuingServe
    getContinuingServe() {
      return this.continuing_serve_id == "0";
    },

    // getHealthStatus
    getHealthStatus() {
      return this.health_status_id.findIndex((x) => x.id != 1) != -1;
    },

    // getFamiliesMartyrs
    getFamiliesMartyrs() {
      return this.families_martyrs_id == "1" || this.families_martyrs_id == "2";
    },

    // getNationalityNumber
    getNationalityNumber() {
      return this.id_type == "1";
    },
    getNationalIdNumber() {
      return this.id_type == "2";
    },

    // multiselect
    onChange() {
      for (let index = 0; index < this.list_health_status.length; index++) {
        this.list_health_status[index]["$isDisabled"] = false;
      }
      if (this.health_status_id.findIndex((o) => o.id == 1) != -1) {
        for (let index = 0; index < this.list_health_status.length; index++) {
          if (this.list_health_status[index].id != 1) {
            this.list_health_status[index]["$isDisabled"] = true;
          }
        }
        this.health_status_id = this.health_status_id.filter((o) => o.id == 1);
      }
    },

    // multiselect
    onChange2() {
      for (let index = 0; index < this.list_government_grants.length; index++) {
        this.list_government_grants[index]["$isDisabled"] = false;
      }
      if (this.government_grants_id.findIndex((o) => o.id == 10) != -1) {
        for (let index = 0; index < this.list_government_grants.length; index++) {
          if (this.list_government_grants[index].id != 10) {
            this.list_government_grants[index]["$isDisabled"] = true;
          }
        }
        this.government_grants_id = this.government_grants_id.filter((o) => o.id == 10);
      }
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">معلومات الجريح الاساسية</h5></div>

      <div class="col-md-12">
        <div class="row">
          <b-form-group class="col-md-3 mb-3" label="الاسم : " label-for="name1">
            <b-form-input
              id="name1"
              type="text"
              placeholder="ادخل الاسم"
              v-model="name1"
              :class="{ 'is-invalid': $v.name1.$error }"
            ></b-form-input>
            <div v-if="$v.name1.$error" class="invalid-feedback">
              <span v-if="!$v.name1.required">هذا الحقل الزامي</span>
              <span v-if="!$v.name1.minLength"
                >يجب أن يتكون الاسم من حرفين على الأقل</span
              >
              <span v-if="!$v.name1.maxLength"
                >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group class="col-md-3 mb-3" label="اسم الاب : " label-for="name2">
            <b-form-input
              id="name2"
              type="text"
              placeholder="ادخل اسم الاب"
              v-model="name2"
              :class="{ 'is-invalid': $v.name2.$error }"
            ></b-form-input>
            <div v-if="$v.name2.$error" class="invalid-feedback">
              <span v-if="!$v.name2.required">هذا الحقل الزامي</span>
              <span v-if="!$v.name2.minLength"
                >يجب أن يتكون الاسم من حرفين على الأقل</span
              >
              <span v-if="!$v.name2.maxLength"
                >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group class="col-md-3 mb-3" label="اسم الجد : " label-for="name3">
            <b-form-input
              id="name3"
              type="text"
              placeholder="ادخل اسم الجد"
              v-model="name3"
              :class="{ 'is-invalid': $v.name3.$error }"
            ></b-form-input>
            <div v-if="$v.name3.$error" class="invalid-feedback">
              <span v-if="!$v.name3.required">هذا الحقل الزامي</span>
              <span v-if="!$v.name3.minLength"
                >يجب أن يتكون الاسم من حرفين على الأقل</span
              >
              <span v-if="!$v.name3.maxLength"
                >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group class="col-md-3 mb-3" label="اسم اب الجد : " label-for="name4">
            <b-form-input
              id="name4"
              type="text"
              placeholder="ادخل اسم اب الجد"
              v-model="name4"
              :class="{ 'is-invalid': $v.name4.$error }"
            ></b-form-input>
            <div v-if="$v.name4.$error" class="invalid-feedback">
              <span v-if="!$v.name4.required">هذا الحقل الزامي</span>
              <span v-if="!$v.name4.minLength"
                >يجب أن يتكون الاسم من حرفين على الأقل</span
              >
              <span v-if="!$v.name4.maxLength"
                >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group class="col-md-3 mb-3" label=" اللقب : " label-for="family_name">
            <b-form-input
              id="family_name"
              type="text"
              placeholder="ادخل اللقب"
              v-model="family_name"
              :class="{ 'is-invalid': $v.family_name.$error }"
            ></b-form-input>
            <div v-if="$v.family_name.$error" class="invalid-feedback">
              <span v-if="!$v.family_name.required">هذا الحقل الزامي</span>
              <span v-if="!$v.family_name.minLength"
                >يجب أن يتكون اللقب من حرفين على الأقل</span
              >
              <span v-if="!$v.family_name.maxLength"
                >يجب أن يتكون اللقب من 15 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-3 mb-3"
            label="اسم الام الثلاثي : "
            label-for="mother_name"
          >
            <b-form-input
              id="mother_name"
              type="text"
              placeholder="ادخل اسم الام الثلاثي"
              v-model="mother_name"
              :class="{ 'is-invalid': $v.mother_name.$error }"
            ></b-form-input>
            <div v-if="$v.mother_name.$error" class="invalid-feedback">
              <span v-if="!$v.mother_name.required">هذا الحقل الزامي</span>
              <span v-if="!$v.mother_name.minLength"
                >يجب أن يتكون اسم الام الثلاثي من حرفين على الأقل</span
              >
              <span v-if="!$v.mother_name.maxLength"
                >يجب أن يتكون اسم الام الثلاثي من 50 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-3 mb-3"
            label="تاريخ التولد : "
            label-for="birth_date"
          >
            <date-picker
              id="birth_date"
              type="date"
              lang="ar"
              value-type="DD-MM-YYYY"
              format="DD-MM-YYYY"
              placeholder="اختر تاريخ التولد"
              v-model="birth_date"
              :class="{ 'is-invalid': $v.birth_date.$error }"
            ></date-picker>
            <div v-if="$v.birth_date.$error" class="invalid-feedback">
              <span v-if="!$v.birth_date.required">هذا الحقل الزامي </span>
              <span v-if="!$v.birth_date.maxValue"
                >يجب ان يكون عمر الجريح من 18 سنة الى 62 سنة
              </span>
              <span v-if="!$v.birth_date.minValue"
                >يجب ان يكون عمر الجريح من 18 سنة الى 62 سنة
              </span>
            </div>
          </b-form-group>
          <b-form-group class="col-md-3 mb-3" label=" الجنس : " label-for="gender_id">
            <select
              class="form-control"
              id="gender_id"
              v-model="gender_id"
              :class="{ 'is-invalid': $v.gender_id.$error }"
            >
              <option value="">اختر الجنس</option>
              <option v-for="gender in list_gender" :value="gender.id" :key="gender.id">
                {{ gender.name }}
              </option>
            </select>
            <div v-if="$v.gender_id.$error" class="invalid-feedback">
              <span v-if="!$v.gender_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group class="col-md-3 mb-3" label=" رقم الهاتف : " label-for="phone1">
            <b-form-input
              id="phone1"
              type="number"
              placeholder="ادخل رقم الهاتف"
              v-model="phone1"
              :class="{ 'is-invalid': $v.phone1.$error }"
            ></b-form-input>
            <div v-if="$v.phone1.$error" class="invalid-feedback">
              <span v-if="!$v.phone1.required">هذا الحقل الزامي</span>
              <span v-if="!$v.phone1.minLength"
                >يجب أن يتكون رقم الهاتف من 11 رقم على الأقل</span
              >
              <span v-if="!$v.phone1.maxLength"
                >يجب أن يتكون رقم الهاتف من 11 رقم على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-3 mb-3"
            label=" الحالة الاجتماعية : "
            label-for="marital_status_id"
          >
            <select
              class="form-control"
              id="marital_status_id"
              v-model="marital_status_id"
              :class="{ 'is-invalid': $v.marital_status_id.$error }"
            >
              <option value="">اختر الحالة الاجتماعية</option>
              <option
                v-for="marital_status in list_marital_status"
                :value="marital_status.id"
                :key="marital_status.id"
              >
                {{ marital_status.name }}
              </option>
            </select>
            <div v-if="$v.marital_status_id.$error" class="invalid-feedback">
              <span v-if="!$v.marital_status_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-3 mb-3"
            label=" التحصيل الدراسي : "
            label-for="certificate_id"
          >
            <select
              class="form-control"
              id="certificate_id"
              v-model="certificate_id"
              :class="{ 'is-invalid': $v.certificate_id.$error }"
            >
              <option value="">اختر التحصيل الدراسي</option>
              <option
                v-for="certificate in list_certificate"
                :value="certificate.id"
                :key="certificate.id"
              >
                {{ certificate.name }}
              </option>
            </select>
            <div v-if="$v.certificate_id.$error" class="invalid-feedback">
              <span v-if="!$v.certificate_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-3 mb-3"
            label="التخصص الدراسي : "
            label-for="academic_specialization"
          >
            <b-form-input
              id="academic_specialization"
              type="text"
              placeholder="ادخل التخصص الدراسي"
              v-model="academic_specialization"
              :class="{ 'is-invalid': $v.academic_specialization.$error }"
            ></b-form-input>
            <div v-if="$v.academic_specialization.$error" class="invalid-feedback">
              <span v-if="!$v.academic_specialization.required">هذا الحقل الزامي</span>
              <span v-if="!$v.academic_specialization.minLength"
                >يجب أن يتكون التخصص الدراسي من حرفين على الأقل</span
              >
              <span v-if="!$v.academic_specialization.maxLength"
                >يجب أن يتكون التخصص الدراسي من 50 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group class="col-md-3 mb-3" label=" التشكيل : " label-for="dept">
            <b-form-input
              id="dept"
              type="text"
              placeholder="ادخل التشكيل"
              v-model="dept"
              :class="{ 'is-invalid': $v.dept.$error }"
            ></b-form-input>
            <div v-if="$v.dept.$error" class="invalid-feedback">
              <span v-if="!$v.dept.required">هذا الحقل الزامي</span>
              <span v-if="!$v.dept.minLength"
                >يجب أن يتكون التشكيل من حرفين على الأقل</span
              >
              <span v-if="!$v.dept.maxLength"
                >يجب أن يتكون التشكيل من 50 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-3 mb-3"
            label=" نسبة العجز : "
            label-for="disability_ratio"
          >
            <b-form-input
              id="disability_ratio"
              type="text"
              placeholder="ادخل نسبة العجز "
              v-model="disability_ratio"
              :class="{ 'is-invalid': $v.disability_ratio.$error }"
            ></b-form-input>
            <div v-if="$v.disability_ratio.$error" class="invalid-feedback">
              <span v-if="!$v.disability_ratio.required">هذا الحقل الزامي</span>
              <span v-if="!$v.disability_ratio.minValue"
                >يجب أن تكون نسبة العجز 1 على الأقل</span
              >
              <span v-if="!$v.disability_ratio.maxValue"
                >يجب أن تكون نسبة العجز 100 على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-3 mb-3"
            label="تاريخ الاصابة : "
            label-for="injury_date"
          >
            <date-picker
              id="injury_date"
              type="date"
              lang="ar"
              value-type="DD-MM-YYYY"
              format="DD-MM-YYYY"
              placeholder="اختر تاريخ الاصابة"
              v-model="injury_date"
              :class="{ 'is-invalid': $v.injury_date.$error }"
            ></date-picker>
            <div v-if="$v.injury_date.$error" class="invalid-feedback">
              <span v-if="!$v.injury_date.required">هذا الحقل الزامي </span>
              <span v-if="!$v.injury_date.maxValue"
                >يجب ان لا يتجاوز تاريخ الاصابة تاريخ اليوم</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-3 mb-3"
            label=" محل الحادث : "
            label-for="scene_accident"
          >
            <b-form-input
              id="scene_accident"
              type="text"
              placeholder="ادخل محل الحادث"
              v-model="scene_accident"
              :class="{ 'is-invalid': $v.scene_accident.$error }"
            ></b-form-input>
            <div v-if="$v.scene_accident.$error" class="invalid-feedback">
              <span v-if="!$v.scene_accident.required">هذا الحقل الزامي</span>
              <span v-if="!$v.scene_accident.minLength"
                >يجب أن يتكون محل الحادث من حرفين على الأقل</span
              >
              <span v-if="!$v.scene_accident.maxLength"
                >يجب أن يتكون محل الحادث من 50 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group
            class="col-md-4 mb-3"
            label="تاريخ التعيين : "
            label-for="employment_date"
          >
            <date-picker
              id="employment_date"
              type="date"
              lang="ar"
              value-type="DD-MM-YYYY"
              format="DD-MM-YYYY"
              placeholder="اختر تاريخ التعيين"
              v-model="employment_date"
              :class="{ 'is-invalid': $v.employment_date.$error }"
            ></date-picker>
            <div v-if="$v.employment_date.$error" class="invalid-feedback">
              <span v-if="!$v.employment_date.required">هذا الحقل الزامي</span>
              <span v-if="!$v.employment_date.maxValue"
                >يجب ان لا يتجاوز تاريخ التعيين تاريخ اليوم</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-4 mb-3"
            label=" هل انت مستفيد من منح حكومية  : "
            label-for="government_grants_id"
          >
            <multiselect
              id="government_grants_id"
              select-label="حدد الاختيار"
              placeholder="اختر المنح الحكومية"
              deselect-label="اظغط هنا لمسح الاختيار"
              selected-label="تم اختياره"
              :options="list_government_grants"
              track-by="id"
              label="name"
              :close-on-select="false"
              :clear-on-select="false"
              :multiple="true"
              v-model="government_grants_id"
              @input="onChange2"
              :class="{ 'is-invalid': $v.government_grants_id.$error }"
            >
              <template slot="singleLabel" slot-scope="{ option }"
                ><strong>{{ option.name }}</strong> is written in<strong>
                  {{ option.name }}</strong
                ></template
              >
            </multiselect>
            <div v-if="$v.government_grants_id.$error" class="invalid-feedback">
              <span v-if="!$v.government_grants_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-4 mb-3"
            label="هل المتقدم من ذوي الشهداء  : "
            label-for="families_martyrs_id"
          >
            <select
              class="form-control"
              id="families_martyrs_id"
              v-model="families_martyrs_id"
              :class="{ 'is-invalid': $v.families_martyrs_id.$error }"
            >
              <option value="">اختر الاجابة</option>
              <option
                v-for="families_martyrs in list_families_martyrs"
                :value="families_martyrs.id"
                :key="families_martyrs.id"
              >
                {{ families_martyrs.name }}
              </option>
            </select>
            <div v-if="$v.families_martyrs_id.$error" class="invalid-feedback">
              <span v-if="!$v.families_martyrs_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
        </div>
        <div class="row" v-if="getFamiliesMartyrs()">
          <b-form-group
            class="col-md-6 mb-3"
            label="فئة الشهيد  : "
            label-for="martyr_class_id"
          >
            <select
              class="form-control"
              id="martyr_class_id"
              v-model="martyr_class_id"
              :class="{ 'is-invalid': $v.martyr_class_id.$error }"
            >
              <option value="">اختر فئة الشهيد</option>
              <option
                v-for="martyr_class in list_martyr_class"
                :value="martyr_class.id"
                :key="martyr_class.id"
              >
                {{ martyr_class.name }}
              </option>
            </select>
            <div v-if="$v.martyr_class_id.$error" class="invalid-feedback">
              <span v-if="!$v.martyr_class_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-6 mb-3"
            label=" اضافة مرفق اثبات ذوي الشهداء :"
            label-for="attachment_families_martyrs"
          >
            <div class="custom_file">
              <b-form-file
                id="attachment_families_martyrs"
                class=""
                placeholder="اختر المرفق"
                accept=".pdf,.jpg,.jpeg,.png"
                v-model="attachment_families_martyrs"
                :class="{ 'is-invalid': $v.attachment_families_martyrs.$error }"
              ></b-form-file>
              <div v-if="$v.attachment_families_martyrs.$error" class="invalid-feedback">
                <span v-if="!$v.attachment_families_martyrs.required"
                  >هذا الحقل الزامي</span
                >
                <span v-if="!$v.attachment_families_martyrs.fileSize"
                  >يجب ان لا يتجاوز حجم الملف 5MB</span
                >
                <span v-if="!$v.attachment_families_martyrs.fileType"
                  >يجب ان يكون نوع الملف .pdf,.jpg,.jpeg,.png
                </span>
              </div>
            </div>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group
            class="col-md-6 mb-3"
            label="اختر نوع البطاقة :"
            label-for="id_type"
          >
            <select
              class="form-control"
              id="id_type"
              v-model="id_type"
              :class="{ 'is-invalid': $v.id_type.$error }"
            >
              <option value="">اختر البطاقة</option>
              <option value="1">بطاقة وطنية</option>
              <option value="2">هوية احوال مدنية</option>
            </select>
            <div v-if="$v.id_type.$error" class="invalid-feedback">
              <span v-if="!$v.id_type.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
          <b-form-group
            v-if="getNationalityNumber()"
            class="col-md-6 mb-3"
            label="رقم البطاقة الوطنية :"
            label-for="nationality_number"
          >
            <b-form-input
              id="nationality_number"
              type="number"
              placeholder="ادخل رقم البطاقة الوطنية"
              v-model="nationality_number"
              :class="{ 'is-invalid': $v.nationality_number.$error }"
            ></b-form-input>
            <div v-if="$v.nationality_number.$error" class="invalid-feedback">
              <span v-if="!$v.nationality_number.required">هذا الحقل الزامي</span>
              <span v-if="!$v.nationality_number.minLength"
                >يجب أن يتكون رقم البطاقة الوطنية من 12 رقم على الأقل</span
              >
              <span v-if="!$v.nationality_number.maxLength"
                >يجب أن يتكون رقم البطاقة الوطنية من 12 رقم على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            v-if="getNationalIdNumber()"
            class="col-md-6 mb-3"
            label="رقم هوية الاحوال المدنية :"
            label-for="national_id_number"
          >
            <b-form-input
              id="national_id_number"
              type="text"
              placeholder="ادخل رقم هوية الاحوال المدنية"
              v-model="national_id_number"
              :class="{ 'is-invalid': $v.national_id_number.$error }"
            ></b-form-input>
            <div v-if="$v.national_id_number.$error" class="invalid-feedback">
              <span v-if="!$v.national_id_number.required">هذا الحقل الزامي</span>
              <span v-if="!$v.national_id_number.minLength"
                >يجب أن يتكون رقم هوية الاحوال المدنية من 8 رقم على الأقل</span
              >
              <span v-if="!$v.national_id_number.maxLength"
                >يجب أن يتكون رقم هوية الاحوال المدنية من 8 رقم على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            v-if="getNationalIdNumber()"
            class="col-md-6 mb-3"
            label="رقم السجل :"
            label-for="national_id_number_record"
          >
            <b-form-input
              id="national_id_number_record"
              type="text"
              placeholder="ادخل رقم السجل"
              v-model="national_id_number_record"
              :class="{ 'is-invalid': $v.national_id_number_record.$error }"
            ></b-form-input>
            <div v-if="$v.national_id_number_record.$error" class="invalid-feedback">
              <span v-if="!$v.national_id_number_record.required">هذا الحقل الزامي</span>
              <span v-if="!$v.national_id_number_record.minLength"
                >يجب أن يتكون رقم السجل من رقم واحد على الأقل</span
              >
              <span v-if="!$v.national_id_number_record.maxLength"
                >يجب أن يتكون رقم السجل من 5 ارقام على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            v-if="getNationalIdNumber()"
            class="col-md-6 mb-3"
            label="رقم الصحيفة :"
            label-for="national_id_number_paper"
          >
            <b-form-input
              id="national_id_number_paper"
              type="text"
              placeholder="ادخل رقم الصحيفة"
              v-model="national_id_number_paper"
              :class="{ 'is-invalid': $v.national_id_number_paper.$error }"
            ></b-form-input>
            <div v-if="$v.national_id_number_paper.$error" class="invalid-feedback">
              <span v-if="!$v.national_id_number_paper.required">هذا الحقل الزامي</span>
              <span v-if="!$v.national_id_number_paper.minLength"
                >يجب أن يتكون رقم الصحيفة من رقم واحد على الأقل</span
              >
              <span v-if="!$v.national_id_number_paper.maxLength"
                >يجب أن يتكون رقم الصحيفة من 5 ارقام على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group
            class="col-md-6 mb-3"
            label=" الوضع الصحي  : "
            label-for="health_status_id"
          >
            <multiselect
              id="health_status_id"
              select-label="حدد الاختيار"
              placeholder="اختر الوضع الصحي"
              deselect-label="اظغط هنا لمسح الاختيار"
              selected-label="تم اختياره"
              :options="list_health_status"
              track-by="id"
              label="name"
              :close-on-select="false"
              :clear-on-select="false"
              :multiple="true"
              v-model="health_status_id"
              @input="onChange"
              :class="{ 'is-invalid': $v.health_status_id.$error }"
            >
              <template slot="singleLabel" slot-scope="{ option }"
                ><strong>{{ option.name }}</strong> is written in<strong>
                  {{ option.name }}</strong
                >
              </template>
            </multiselect>
            <div v-if="$v.health_status_id.$error" class="invalid-feedback">
              <span v-if="!$v.health_status_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-6 mb-3"
            label=" هل انت مستمر بالخدمة  : "
            label-for="continuing_serve_id"
          >
            <select
              class="form-control"
              id="continuing_serve_id"
              v-model="continuing_serve_id"
              :class="{ 'is-invalid': $v.continuing_serve_id.$error }"
            >
              <option value="">اختر الاجابة</option>
              <option
                v-for="continuing_serve in list_continuing_serve"
                :value="continuing_serve.id"
                :key="continuing_serve.id"
              >
                {{ continuing_serve.name }}
              </option>
            </select>
            <div v-if="$v.continuing_serve_id.$error" class="invalid-feedback">
              <span v-if="!$v.continuing_serve_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group
            v-if="getContinuingServe()"
            class="col-md-12 mb-3"
            label="الرقم التقاعدي : "
            label-for="retirement_number"
          >
            <b-form-input
              id="retirement_number"
              type="number"
              placeholder="ادخل الرقم التقاعدي"
              v-model="retirement_number"
              :class="{ 'is-invalid': $v.retirement_number.$error }"
            ></b-form-input>
            <div v-if="$v.retirement_number.$error" class="invalid-feedback">
              <span v-if="!$v.retirement_number.required">هذا الحقل الزامي</span>
              <span v-if="!$v.retirement_number.minLength"
                >يجب أن يتكون الرقم التقاعدي من 6 ارقام على الأقل</span
              >
              <span v-if="!$v.retirement_number.maxLength"
                >يجب أن يتكون الرقم التقاعدي من 10 ارقام على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="row" v-if="getHealthStatus()">
          <b-form-group
            class="col-md-12 mb-3"
            label=" مرفق الوضع الصحي :"
            label-for="attachment_health"
          >
            <div class="custom_file">
              <b-form-file
                id="attachment_health"
                class=""
                placeholder="اختر المرفق"
                accept=".pdf,.jpg,.jpeg,.png"
                v-model="attachment_health"
                :class="{ 'is-invalid': $v.attachment_health.$error }"
              ></b-form-file>
              <div v-if="$v.attachment_health.$error" class="invalid-feedback">
                <span v-if="!$v.attachment_health.required">هذا الحقل الزامي</span>
                <span v-if="!$v.attachment_health.fileSize"
                  >يجب ان لا يتجاوز حجم الملف 5MB</span
                >
                <span v-if="!$v.attachment_health.fileType"
                  >يجب ان يكون نوع الملف .pdf,.jpg,.jpeg,.png
                </span>
              </div>
            </div>
          </b-form-group>
        </div>
        <div class="row">
          <hr class="hr-title" />
          <div class="break-title"><h5 class="mb-4">عنوان السكن</h5></div>
          <b-form-group class="col-md-4 mb-3" label=" المحافظة  : " label-for="city_id">
            <select
              class="form-control"
              id="city_id"
              v-model="city_id"
              :class="{ 'is-invalid': $v.city_id.$error }"
            >
              <option value="">اختر المحافظة</option>
              <option v-for="city in list_city" :value="city.id" :key="city.id">
                {{ city.name }}
              </option>
            </select>
            <div v-if="$v.city_id.$error" class="invalid-feedback">
              <span v-if="!$v.city_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
          <b-form-group class="col-md-4 mb-3" label="القضاء : " label-for="district">
            <b-form-input
              id="district"
              type="text"
              placeholder="ادخل القضاء"
              v-model="district"
              :class="{ 'is-invalid': $v.district.$error }"
            ></b-form-input>
            <div v-if="$v.district.$error" class="invalid-feedback">
              <span v-if="!$v.district.required">هذا الحقل الزامي</span>
              <span v-if="!$v.district.minLength"
                >يجب أن يتكون القضاء من حرفين على الأقل</span
              >
              <span v-if="!$v.district.maxLength"
                >يجب أن يتكون القضاء من 50 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group class="col-md-4 mb-3" label="الناحية : " label-for="region">
            <b-form-input
              id="region"
              type="text"
              placeholder="ادخل الناحية"
              v-model="region"
              :class="{ 'is-invalid': $v.region.$error }"
            ></b-form-input>
            <div v-if="$v.region.$error" class="invalid-feedback">
              <span v-if="!$v.region.required">هذا الحقل الزامي</span>
              <span v-if="!$v.region.minLength"
                >يجب أن تتكون الناحية من حرفين على الأقل</span
              >
              <span v-if="!$v.region.maxLength"
                >يجب أن تتكون الناحية من 50 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group class="col-md-4 mb-3" label="محلة : " label-for="mahla">
            <b-form-input
              id="mahla"
              type="text"
              placeholder="ادخل المحلة"
              v-model="mahla"
            ></b-form-input>
          </b-form-group>
          <b-form-group class="col-md-4 mb-3" label="زقاق : " label-for="zqaq">
            <b-form-input
              id="zqaq"
              type="text"
              placeholder="ادخل الزقاق"
              v-model="zqaq"
            ></b-form-input>
          </b-form-group>
          <b-form-group class="col-md-4 mb-3" label="دار : " label-for="dar">
            <b-form-input
              id="dar"
              type="text"
              placeholder="ادخل الدار"
              v-model="dar"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="row">
          <hr class="hr-title" />
          <div class="break-title"><h5 class="mb-4">معلومات المُلكية الحالية</h5></div>
          <b-form-group
            class="col-md-3 mb-3"
            label=" هل تمتلك عقار اخر بأسمك  : "
            label-for="own_property_id"
          >
            <select
              class="form-control"
              id="own_property_id"
              v-model="own_property_id"
              :class="{ 'is-invalid': $v.own_property_id.$error }"
            >
              <option value="">اختر الاجابة</option>
              <option
                v-for="own_property in list_own_property"
                :value="own_property.id"
                :key="own_property.id"
              >
                {{ own_property.name }}
              </option>
            </select>
            <div v-if="$v.own_property_id.$error" class="invalid-feedback">
              <span v-if="!$v.own_property_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-3 mb-3"
            label=" نوع السكن  : "
            label-for="house_type_id"
          >
            <select
              class="form-control"
              id="house_type_id"
              v-model="house_type_id"
              :class="{ 'is-invalid': $v.house_type_id.$error }"
            >
              <option value="">اختر نوع السكن</option>
              <option
                v-for="house_type in list_house_type"
                :value="house_type.id"
                :key="house_type.id"
              >
                {{ house_type.name }}
              </option>
            </select>
            <div v-if="$v.house_type_id.$error" class="invalid-feedback">
              <span v-if="!$v.house_type_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-3 mb-3"
            label=" خصوصية السكن  : "
            label-for="housing_privacy_id"
          >
            <select
              class="form-control"
              id="housing_privacy_id"
              v-model="housing_privacy_id"
              :class="{ 'is-invalid': $v.housing_privacy_id.$error }"
            >
              <option value="">اختر خصوصية السكن</option>
              <option
                v-for="housing_privacy in list_housing_privacy"
                :value="housing_privacy.id"
                :key="housing_privacy.id"
              >
                {{ housing_privacy.name }}
              </option>
            </select>
            <div v-if="$v.housing_privacy_id.$error" class="invalid-feedback">
              <span v-if="!$v.housing_privacy_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-3 mb-3"
            label="نوع البناء  : "
            label-for="construction_type_id"
          >
            <select
              class="form-control"
              id="construction_type_id"
              v-model="construction_type_id"
              :class="{ 'is-invalid': $v.construction_type_id.$error }"
            >
              <option value="">اختر نوع البناء</option>
              <option
                v-for="construction_type in list_construction_type"
                :value="construction_type.id"
                :key="construction_type.id"
              >
                {{ construction_type.name }}
              </option>
            </select>
            <div v-if="$v.construction_type_id.$error" class="invalid-feedback">
              <span v-if="!$v.construction_type_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group
            class="col-md-4 mb-3"
            label="حالة البناء  : "
            label-for="construction_condition_id"
          >
            <select
              class="form-control"
              id="construction_condition_id"
              v-model="construction_condition_id"
              :class="{ 'is-invalid': $v.construction_condition_id.$error }"
            >
              <option value="">اختر حالة البناء</option>
              <option
                v-for="construction_condition in list_construction_condition"
                :value="construction_condition.id"
                :key="construction_condition.id"
              >
                {{ construction_condition.name }}
              </option>
            </select>
            <div v-if="$v.construction_condition_id.$error" class="invalid-feedback">
              <span v-if="!$v.construction_condition_id.required">هذا الحقل الزامي</span>
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-4 mb-3"
            label="مساحة السكن : "
            label-for="housing_area"
          >
            <b-form-input
              id="housing_area"
              type="number"
              placeholder="ادخل مساحة السكن"
              v-model="housing_area"
              :class="{ 'is-invalid': $v.housing_area.$error }"
            ></b-form-input>
            <div v-if="$v.housing_area.$error" class="invalid-feedback">
              <span v-if="!$v.housing_area.required">هذا الحقل الزامي</span>
              <span v-if="!$v.housing_area.minValue"
                >يجب أن تكون مساحة السكن 50 متر على الأقل</span
              >
              <span v-if="!$v.housing_area.maxValue"
                >يجب أن تكون مساحة السكن 1200 متر على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-4 mb-3"
            label="عدد الطوابق : "
            label-for="number_floors"
          >
            <b-form-input
              id="number_floors"
              type="number"
              placeholder="ادخل عدد الطوابق"
              v-model="number_floors"
              :class="{ 'is-invalid': $v.number_floors.$error }"
            ></b-form-input>
            <div v-if="$v.number_floors.$error" class="invalid-feedback">
              <span v-if="!$v.number_floors.required">هذا الحقل الزامي</span>
              <span v-if="!$v.number_floors.minValue"
                >يجب أن تكون عدد الطوابق طابق واحد على الأقل</span
              >
              <span v-if="!$v.number_floors.maxValue"
                >يجب أن تكون عدد الطوابق 4 طوابق على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="row">
          <hr class="hr-title" />
          <div class="break-title">
            <h5 class="mb-4">المرفقات الثبوتية</h5>
          </div>

          <ul class="" style="margin-right: 16px">
            <li class="mb-1">
              <h5 class="font-size-14">
                البطاقة الوطنية او ما يعادلها (هوية الاحوال المدنية + شهادة الجنسية)
              </h5>
            </li>
            <li class="mb-1">
              <h5 class="font-size-14">البطاقة التموينية</h5>
            </li>
            <li class="mb-1">
              <h5 class="font-size-14">بطاقة السكن</h5>
            </li>
            <li class="mb-1">
              <h5 class="font-size-14">
                يجب جمع المرفقات الثبوتية للجريح اعلاه ورفعها بصيغة ( pdf .jpg .jpeg .png.
                ) وبحجم لا يتجاوز ( 5MB ) .
              </h5>
            </li>
          </ul>

          <b-form-group
            class="col-md-12 mb-3"
            label=" المرفقات الثبوتية :"
            label-for="attachment_basic"
          >
            <div class="custom_file">
              <b-form-file
                id="attachment_basic"
                class=""
                placeholder="اختر المرفق"
                accept=".pdf,.jpg,.jpeg,.png"
                v-model="attachment_basic"
                :class="{ 'is-invalid': $v.attachment_basic.$error }"
              ></b-form-file>
              <div v-if="$v.attachment_basic.$error" class="invalid-feedback">
                <span v-if="!$v.attachment_basic.required">هذا الحقل الزامي</span>
                <span v-if="!$v.attachment_basic.fileSize"
                  >يجب ان لا يتجاوز حجم الملف 5MB</span
                >
                <span v-if="!$v.attachment_basic.fileType"
                  >يجب ان يكون نوع الملف .pdf,.jpg,.jpeg,.png
                </span>
              </div>
            </div>
          </b-form-group>

          <hr class="hr-title" />
          <div class="break-title">
            <h5 class="mb-4">مرفق تأييد الاصابة</h5>
          </div>

          <ul class="" style="margin-right: 16px">
            <li class="mb-1">
              <h5 class="font-size-14">
                مرفق تأييد المجروحية وقرار نسبة العجز من الادارة المركزية حصراً .
              </h5>
            </li>
            <li class="mb-1">
              <h5 class="font-size-14">
                يجب جمع مرفقات تأييد الاصابة للجريح اعلاه ورفعها بصيغة ( pdf .jpg .jpeg
                .png. ) وبحجم لا يتجاوز ( 5MB ) .
              </h5>
            </li>
          </ul>

          <b-form-group
            class="col-md-12 mb-3"
            label=" مرفق تأييد الاصابة :"
            label-for="attachment_disability_ratio"
          >
            <div class="custom_file">
              <b-form-file
                id="attachment_disability_ratio"
                class=""
                placeholder="اختر المرفق"
                accept=".pdf,.jpg,.jpeg,.png"
                v-model="attachment_disability_ratio"
                :class="{ 'is-invalid': $v.attachment_disability_ratio.$error }"
              ></b-form-file>
              <div v-if="$v.attachment_disability_ratio.$error" class="invalid-feedback">
                <span v-if="!$v.attachment_disability_ratio.required"
                  >هذا الحقل الزامي</span
                >
                <span v-if="!$v.attachment_disability_ratio.fileSize"
                  >يجب ان لا يتجاوز حجم الملف 5MB</span
                >
                <span v-if="!$v.attachment_disability_ratio.fileType"
                  >يجب ان يكون نوع الملف .pdf,.jpg,.jpeg,.png
                </span>
              </div>
            </div>
          </b-form-group>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
